(() => {
/*
 * Renders a panel impressions to impressions ratio chart
 */
  angular
    .module('app.components')
    .directive('panelImpressionsToImpressionsRatioChart', ['$filter', 'ChartService', function ($filter, ChartService) {
      return {
        restrict: "E",
        scope: {
          data: '='
        },
        template: '<highchart id="panelImpsToImpsRatio" config="config"></highchart>',
        link: function (scope) {
          scope.$watch('data', function (newValue) {
            if (newValue) scope.config.refreshData(newValue);
          }, true);
        },
        // NOTE: DO NOT move the config options to the link function.
        // See : https://github.com/pablojim/highcharts-ng/issues/384
        controller: function($scope) {
          var startWeek = 1;
          var maxNumberOfWeeksToRender = 12;

          var options = ChartService.getBaseChartConfig();
          angular.merge(options, {
            chart: {
              spacingTop: 10
            },
            tooltip: {
              formatter: function () {
                return '<h4> Week ' + (startWeek + this.x) + '</h4><div class="highcharts-tooltip-outer"><table class="highcharts-tooltip-inner"><tr><td class="td-left">' +
                  this.points[0].series.name + ':</td><td class="td-right">' + $filter('customNumber')(this.y, 2) + '%</td></tr></table></div>';
              }
            },
            legend: {
              enabled: false
            },
            xAxis: {
              labels: {
                formatter: function () {
                  return "Week " + (startWeek + this.value);
                }
              }
            },
            yAxis: {
              min: 0
            },
            plotOptions: {
              areaspline: {}
            }
          });

          //override default color scheme
          options.colors = ['#16d6d8'];

          $scope.config = {
            options: options,
            refreshData: function (dataSource) {
              if (angular.isUndefined(dataSource)) return;
              this.series = [{
                name: 'Ratio',
                data: $filter('limitTo')(_.pluck(_.values(dataSource), 'ratio'), maxNumberOfWeeksToRender)
              }];
            }
          };
        }
      }
    }]);
})();
